import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { getBrandDetailsProducts } from "@sunSource/Services/BrandDetailsProductService";
import BrandDetailsCustomProductsModel from "@sunSource/Store/Data/BrandDetailsCustomProducts/BrandDetailsCustomProductsState";

export interface LoadProductsByBrandId {
    brandId: string;
}

type HandlerType = ApiHandlerDiscreteParameter<LoadProductsByBrandId, GetProductCollectionApiV2Parameter, BrandDetailsCustomProductsModel>;

export const RequestDataFromApi: HandlerType = async props => {
    const brand = await getBrandDetailsProducts(props.parameter);
    props.apiParameter = {
        productIds: brand.popularProducts.map(item => item.productId),
        pageSize: 8,
    }
};

export const CallProductDetails: HandlerType = props => {
    props.dispatch(
        loadProductInfoList({
            id: "brandDetailsPage",
            getProductCollectionParameter: props.apiParameter,
            forceLoad: true,
        })
    )
};

export const chain = [RequestDataFromApi, CallProductDetails];

const loadBrandDetailsProducts = createHandlerChainRunner(chain, "LoadBrandDetailsProductsById");
export default loadBrandDetailsProducts;